// @ts-ignore
import store from "@/store"
import { NavigationGuardNext, Route } from "vue-router"

// Pass if the user is not logged in
export function isAnonymous(to: Route, from: Route, next: NavigationGuardNext) {
  if (store.getters["me/token"]) {
    return next({ name: "appointments_calendar" })
  } else {
    return next()
  }
}

// Pass if the user is logged in
export function isAuthenticated(to: Route, from: Route, next: NavigationGuardNext) {
  // console.log("from:", from.fullPath, "to:", to.fullPath)
  if (store.getters["me/isLoggedIn"]) {
    return next()
  } else {
    return next({ name: "login", query: { ...to.query, redirectedFromPath: to.fullPath } })
  }
}

// Pass if the user is clinical admin
export function isClinicalAdmin(to: Route, from: Route, next: NavigationGuardNext) {
  if (store.getters["me/token"] && store.getters["me/isClinicalAdmin"]) {
    return next()
  } else {
    return next({ name: "appointments_calendar" })
  }
}
